import { curry } from "ramda";
window.seatsPromoCode = curry(function ($form) {
  var promocodeUrl = $form.attr("action");
  var getArenaWithPromocode = function (url, promocode) {
    return $.getJSON(url, { promocode: promocode });
  };

  $form.submit(function (event) {
    event.preventDefault();
    var $promocode = $form.find("[name=promocode]");
    getArenaWithPromocode(promocodeUrl, $promocode.val())
      .done(function (res) {
        $form.trigger("seats:update", res);
        $promocode.val("");
        showNotification(TC_LABELS.PROMO_CODE_APPLIED, "alert-success");
      })
      .fail(function () {
        showNotification(TC_LABELS.PROMO_CODE_INVALID, "alert-error");
      });
  });

  return {
    $: $form,
  };
});
